import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import Button from 'Components/Button';
import styles from './styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

class ButtonRow extends Component {
  static propTypes = {
    className: PropTypes.string,
    secondaryBtn: PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
      additionalProps: PropTypes.object,
      additionalAttributes: PropTypes.object,
    }),
    primaryBtn: PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      small: PropTypes.bool,
      disabled: PropTypes.bool,
      additionalProps: PropTypes.object,
      additionalAttributes: PropTypes.object,
    }),
    tertiaryBtn: PropTypes.node,
    withBottomSpace: PropTypes.string,
  };

  render() {
    const { secondaryBtn, primaryBtn, tertiaryBtn, forwardedRef, className, withBottomSpace } =
      this.props;

    return (
      <div
        className={cx('buttonRow', { onlySecondary: secondaryBtn && !primaryBtn }, className)}
        ref={forwardedRef}
        data-with-bottomspace={withBottomSpace || 'false'}
      >
        <div className={styles.wrapper}>
          <div className={styles.primaryWrapper}>
            {primaryBtn && (
              <Button
                label={primaryBtn.label}
                onClick={primaryBtn.onClick}
                small={primaryBtn.small}
                disabled={primaryBtn.disabled}
                additionalProps={primaryBtn.additionalProps}
                {...primaryBtn.additionalAttributes}
              />
            )}

            {tertiaryBtn && <div className={styles.tertiaryWrapper}>{tertiaryBtn}</div>}
          </div>

          <div className={styles.secondaryWrapper}>
            {secondaryBtn && (
              <Button
                label={secondaryBtn.label}
                onClick={secondaryBtn.onClick}
                variant="secondary"
                additionalProps={secondaryBtn.additionalProps}
                {...secondaryBtn.additionalAttributes}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default forwardRef((props, ref) => <ButtonRow {...props} forwardedRef={ref} />);
